export default {
  lenguajes: [
    {
      label: 'Español',
      value: 'es'
    },
    {
      label: 'English',
      value: 'en'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/services/lenguajes.js